import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import NavigationMenu from './components/NavigationMenu';
import HomePage from './components/HomePage';
import LeaguePage from './components/LeaguePage';
import TeamComparisons from './components/TeamComparisons';
import Summary from './components/Summary';
import EloRanking from './components/EloRanking';
import PositionMatrix from './components/PositionMatrix';
import BlogList from './components/BlogList';
import ArticlePage from './components/ArticlePage';
import LeagueTables from './components/LeagueTables';
import SimulationResults from './components/SimulationResults';
import Fixtures from './components/Fixtures';
import YourSimulation from './components/yourSimulation';
import Login from './components/Login';
import Register from './components/Register';
import { AuthGuard } from './components/AuthGuard';
import AdminPanel from './components/AdminPanel';
import AddMatch from './components/AddMatch';
import ManageSimulations from './components/ManageSimulations';
import CreatePost from './components/CreatePost';
import PointsThreshold from './components/PointsThreshold';
import TeamPage from './components/TeamPage';
import FixtureDifficulty from './components/FixtureDifficulty';
import CompetitionEloRanking from './components/CompetitionEloRanking'; // Nowy komponent
import AchievementRanking from './components/achievements/AchievementRanking';
import AchievementList from './components/achievements/AchievementList';
import RequireVip from './components/RequireVip';
import ScrollRestoration from './components/ScrollRestoration';
import TeamAnalytics from './components/TeamAnalytics';
import LeagueManager from './components/AdminPanel/LeagueManager';
import Playoff from './components/Playoff';
import { HelmetProvider } from 'react-helmet-async';
import { darkTheme } from './components/theme';
import { CompetitionProvider } from './components/CompetitionContext';

function App() {
    console.log('App rendered');
    return (
        <ThemeProvider theme={darkTheme}>
            <CompetitionProvider>
                <BrowserRouter>
                    <Box sx={{ minHeight: '100vh', background: darkTheme.palette.background.default }}>
                        <header style={{ textAlign: 'center', padding: '20px 0' }}>
                            <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '3rem' } }}>
                                SYMULIGA.PL
                            </Typography>
                            <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 2 }}>
                                Symulator polskich lig piłkarskich
                            </Typography>
                        </header>

                        <NavigationMenu />

                        <Box sx={{ padding: { xs: '5px', md: '20px' } }}>
							<ScrollRestoration />
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/liga/:id/:slug?" element={<LeaguePage />} />
                                <Route path="/liga/:competitionId/positionMatrix" element={<PositionMatrix />} />
								<Route path="/liga/:competitionId/playoff" element={<Playoff />} />
                                <Route path="/liga/:competitionId/team-comparisons" element={<TeamComparisons />} />
                                <Route path="/liga/:competitionId/summary" element={<Summary />} />
                                <Route path="/liga/:competitionId/fixtures" element={<Fixtures />} />
                                <Route path="/liga/:competitionId/points-threshold" element={<PointsThreshold />} />
								<Route path="/liga/:competitionId/fixture_difficulty" element={<FixtureDifficulty />} />
                                <Route path="/liga/:id/leagueTables" element={<LeagueTables />} />
                                <Route path="/liga/:id/yourSimulation" element={<YourSimulation />} />
                                <Route path="/liga/:competitionId/elo-ranking" element={<CompetitionEloRanking />} /> {/* Nowy route */}
								<Route path="/achievements/:category" element={<RequireVip variant='vip-teaser' requirement='poland'><AchievementRanking /></RequireVip>} />
								<Route path="/achievements-list" element={<AchievementList />} />
								<Route path="/team/:id/analytics" element={<TeamAnalytics />} />
								<Route path="/team/:teamId/:slug?" element={<TeamPage />} />
                                <Route path="/elo-ranking" element={<EloRanking />} />
                                <Route path="/blog" element={<BlogList />} />
                                <Route path="/blog/:slug" element={<ArticlePage />} />
                                <Route path="/simulation-results" element={<SimulationResults />} />
                                <Route path="/janekjot" element={<AuthGuard requiredRole="admin"><AdminPanel /></AuthGuard>} />
                                <Route path="/janekjot/addMatch" element={<AuthGuard requiredRole="admin"><AddMatch /></AuthGuard>} />
                                <Route path="/janekjot/manageSimulations" element={<AuthGuard requiredRole="admin"><ManageSimulations /></AuthGuard>} />
								<Route path="/janekjot/leagueManager" element={<AuthGuard requiredRole="admin"><LeagueManager /></AuthGuard>} />
								<Route path="/janekjot/createPost" element={<AuthGuard requiredRole="admin"><CreatePost /></AuthGuard>} />
                                <Route path="*" element={<Typography variant="h6" sx={{ textAlign: 'center' }}>404 - Strona nie znaleziona</Typography>} />
                            </Routes>
                        </Box>

                        <footer style={{ textAlign: 'center', padding: '20px 0', backgroundColor: '#1a1a1a' }}>
                            <Typography variant="body2">
                                © 2026 SymuLiga.pl. Wszystkie prawa zastrzeżone.
                            </Typography>
                        </footer>
                    </Box>
                </BrowserRouter>
            </CompetitionProvider>
        </ThemeProvider>
    );
}

export default App;